import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { useAuth } from '../hooks/useAuth';
import { authApi } from '../services/auth-api';
import { getOAuthCallbackData } from '../services/oauth';

export function OAuthCallbackPage() {
  const { setAuthState } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const data = getOAuthCallbackData();
    if (!data) {
      setError('Falha na autenticação OAuth. Parametros inválidos.');
      return;
    }

    authApi
      .oauthLogin(data.provider, data.code, data.codeVerifier)
      .then((response) => {
        setAuthState(response.user, {
          accessToken: response.accessToken,
          refreshToken: response.refreshToken,
          expiresIn: response.expiresIn,
        });
        navigate('/', { replace: true });
      })
      .catch(() => {
        setError('Falha na autenticação. Tente novamente.');
      });
  }, [navigate, setAuthState]);

  if (error) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 2 }}>
        <Alert severity="error" sx={{ mb: 2, maxWidth: 400 }}>
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="body1" color="text.secondary">
        Autenticando...
      </Typography>
    </Box>
  );
}
